import { css } from "@emotion/react"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"
import { container } from "@mkt/cp/src/styles/Functions"
import { below, above } from "@mkt/cp/src/styles/Breakpoints"

export const tabs = css`
  padding-block: 24px;
  background-color: ${colorsCP["neutral-10"]};
  ${above["l"]} {
    padding-block: 72px;
  }
`
export const tabsContainer = css`
  ${container};
  display: flex;
  gap: 32px;

  ${below["l"]} {
    gap: 24px;
    flex-direction: column;
  }

  > div {
    ${above["l"]} {
      flex: 0 1 50%;
      max-width: 50%;
    }
  }
`
export const tabsTitle = css`
  margin-bottom: 16px;

  ${above["l"]} {
    margin-bottom: 24px;
  }
`
export const tabsText = css`
  color: ${colorsCP["neutral-50"]};
  font-size: 16px;
  line-height: 24px;

  ${above["l"]} {
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 64px;
  }
`
export const tabsImg = css`
  display: none;
  max-width: 100%;
  height: auto;

  ${above["l"]} {
    display: block;
  }
`
export const tabTitles = css`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 0;
  }

  ${below["m"]} {
    padding-right: 24px;
    margin-right: -24px;
  }

  ${above["m"]} {
    gap: 24px;
  }
`
export const tabItemTitle = css`
  width: 100%;
  cursor: pointer;
  font-weight: 600;
  line-height: 24px;
  padding: 7px 16px;
  text-align: center;
  border-radius: 500px;
  transition: all 0.15s ease-in-out;
  color: ${colorsCP["neutral-50"]};
  border: 1px solid ${colorsCP["neutral-30"]};

  &:hover,
  &.active {
    color: ${colorsCP["blue-40"]};
    border-color: ${colorsCP["blue-30"]};
    background-color: ${colorsCP["blue-10"]};
  }
`
export const tabItemDescription = css`
  color: ${colorsCP["neutral-50"]};
  line-height: 24px;

  &.active {
    display: block;
    opacity: 1;
    animation: fadeIn 0.5s forwards;
  }

  &.inactive {
    display: none;
    opacity: 0;
    animation: fadeOut 0.5s forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  > p {
    margin-bottom: 10px;
  }

  ol {
    padding-left: 20px;
    margin-block: 24px;

    > li {
      list-style: decimal;
    }
  }
`
export const tabItemDescriptionTitle = css`
  color: ${colorsCP["neutral-70"]};
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 8px;
`
